<app-datatable [identifier]="'activities-table'" [title]="title" [hidden]="detailState !== ActivitiesDetailsState.INIT"
  (actionmenuevent)="actionMenuClicked($event)" [cols]="cols" [rows]="activities" [pagination]="true" [total]="total" [isloading]="loading"
  (pageevent)="onPageChange($event)" [isSortable]="false" (rowclickevent)="activitiesRowClick($event)" [showfiltericon]="true"
[filters]="activitiesTableFilter" [showremoveallicon]="showRemoveAllActivities" (onclickheaderremoveall)="removeAllActivitiesTable($event)"></app-datatable>
@if (detailState == ActivitiesDetailsState.VIEW_DETAILS) {
  <div class="ot-panel" animate.enter="enter-animation">
    <div class="otsc-activities-detail-container">
      <div class="otsc-activities-detail-container_nav" style="border-right: 1px solid #d5d5d5;">
        <div class="back-container">
          <button (click)="goBack()" aria-label="Back" i18n-title title="Back" class="otsc-btn__back ot-btn ot-btn--is-micro ot-btn--is-icon-btn">
            <div class="ot-icon ot-icon__action" id="otsc-activities-detail__back_btn">
            </div>
          </button>
        </div>
        <div class="otsc-text__back" i18n>Activities</div>
      </div>
      <div class="otsc-activities-detail-container_nav d-block" style="padding: 5px 20px 5px 15px">
        <div class="ot-level">
          <div class="ot-level__left">
            <div class="ot-level__item">
              <div class="otsc-ua-report-title" i18n>
              {{ currentActivity.friendlyName + ' details'}}
            </div>
            </div>
          </div>
          <div class="ot-level__center">
            <div class="ot-level__item"></div>
          </div>
          <div class="ot-level__right">
            <div class="ot-level__item">
              @if (currentActivity.name == 'PACKAGE_PROD_LOGS') {
                <button class="ot-btn ot-btn--is-primary" title="View details" i18n-title i18n (click)="viewDetails()">View details</button>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="otsc-activities-detail-container_content" style="border-right: 1px solid #d5d5d5;height: calc(100vh - 160px);">
        <ng-scrollbar>
          <ul id="activityOverviewList" class="ot-list" style="padding-top: 8px; max-width: 258px;">
            @for (row of activities; track row; let i = $index) {
              <li (click)="setCurrentActivity(row.data, true)" (keyup.enter)="setCurrentActivity(row.data, true)" [tabindex]="i == 0 ? 0 : -1" class="ot-list__item"
                [ngClass]="{'otsc-activities-item_selected': row.data.id === currentActivity.id}" (keydown)="onActivityListKeyDown($event, row, i)">
                <div>
                  @if (row.data.status == 'COMPLETED') {
                    <i class="otsc-activity-status-icon otsc-icon-status-success"></i>
                  }
                  @if (row.data.status == 'RUNNING') {
                    <i class="otsc-activity-status-icon otsc-icon-status-loading-spinner"></i>
                  }
                  @if (row.data.status == 'ERROR') {
                    <i class="otsc-activity-status-icon otsc-icon-status-error"></i>
                  }
                  @if (row.data.status == 'CANCELED') {
                    <i class="otsc-activity-status-icon otsc-icon-status-cancelled"></i>
                  }
                  @if (row.data.status == 'QUEUED') {
                    <i class="otsc-activity-status-icon otsc-icon-status-waiting"></i>
                  }
                </div>
                <span [title]="row.data.friendlyName">{{row.data.friendlyName}}</span>
              </li>
            }
          </ul>
        </ng-scrollbar>
      </div>
      <div class="otsc-activities-item-container_content">
        <div class="ot-panel__header">
          <app-tabs [identifier]="'other-activity-property-tabs'" (selected)="onSelectedPropertyTabChange($event)" [tabs]="activityPropertyTabs" [color]="TabColor.SECONDARY" [selectedIndex]="activePropertyTab"></app-tabs>
        </div>
        <div style="overflow: auto;height: 100vh;">
          <div>
            @if (activePropertyTab === ActivityPropertyTab.GENERAL) {
              <div id="otsc-activity-general" class="otsc-activities-section" style="height: calc(100vh - 190px);">
                @if (!analyzing) {
                  <ng-scrollbar>
                    <div class="otsc-activities-section-title ot-pl-3 ot-pr-3" i18n>General</div>
                    <div class="otsc-metadata ot-pt-1 ot-pb-1 ot-pl-4 ot-pr-2">
                      <div class="ot-row" data-activity-metadata-row="id">
                        <div class="ot-row__column otsc-metadata-key">
                          <small class="ot--has-text-muted" i18n>Id</small>
                        </div>
                        <div class="ot-row__column otsc-metadata-value">
                          <p>{{currentActivity.id}}</p>
                        </div>
                      </div>
                      <div class="ot-row" data-activity-metadata-row="env">
                        <div class="ot-row__column otsc-metadata-key">
                          <small class="ot--has-text-muted" i18n>Environment</small>
                        </div>
                        <div class="ot-row__column otsc-metadata-value">
                          <p>{{currentActivity.envStr}}</p>
                        </div>
                      </div>
                      <div class="ot-row" data-activity-metadata-row="created-by">
                        <div class="ot-row__column otsc-metadata-key">
                          <small class="ot--has-text-muted" i18n>Created by</small>
                        </div>
                        <div class="ot-row__column otsc-metadata-value">
                          <p>{{currentActivity.initiatedBy}}</p>
                        </div>
                      </div>
                      <div class="ot-row" data-activity-metadata-row="created-date">
                        <div class="ot-row__column otsc-metadata-key">
                          <small class="ot--has-text-muted" i18n>Created date</small>
                        </div>
                        <div class="ot-row__column otsc-metadata-value">
                          <p>{{currentActivity.createdDateTime | fromNow}}</p>
                        </div>
                      </div>
                      <div class="ot-row" data-activity-metadata-row="current-status">
                        <div class="ot-row__column otsc-metadata-key">
                          <small class="ot--has-text-muted" i18n>Status</small>
                        </div>
                        <div class="ot-row__column otsc-metadata-value">
                          <div class="ot-icon ot-icon--is-16x16 ot-pl-1">
                            @switch (currentActivity.status) {
                              @case ('COMPLETED') {
                                <img src="./assets/icons/success.svg" title="Completed" i18-title>
                              }
                              @case ('ERROR') {
                                <img src="./assets/icons/formfield_error.svg" title="Error" i18-title>
                              }
                              @case ('CANCELED') {
                                <img src="./assets/icons/status_cancelled.svg" title="Canceled" i18-title>
                              }
                              @case ('QUEUED') {
                                <img src="./assets/icons/waiting_for_approval_status.svg" title="Queued" i18-title>
                              }
                              @case ('RUNNING') {
                                <div class="ot-progress-container" title="Running" i18-title>
                                  <div id="ot-spinner" class="ot-progress ot-progress--is-spinner">
                                    <div class="ot-progress__outer">
                                      <div class="ot-progress__meter otsc-activity-progress-spinner">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                            }
                          </div>
                        </div>
                      </div>
                      @if (currentActivity.name == 'PATCH_INSTALLATION' || currentActivity.name == 'BRING_UP_TO_DATE' || currentActivity.name == 'SYNC_PATCH_INSTALLATION') {
                        <div class="ot-row">
                          <div class="ot-row__column otsc-metadata-key">
                            <small class="ot--has-text-muted" i18n>Installation type:</small>
                          </div>
                          <div class="ot-row__column otsc-metadata-value">
                            @if(currentActivity.installTaskType == 0) {
                              <p i18n>Classic</p>
                            } @else {
                              <p i18n>Zero downtime</p>
                            }
                          </div>
                        </div>
                        <div class="ot-row">
                          <div class="ot-row__column otsc-metadata-key">
                            <small class="ot--has-text-muted" i18n>Skip reapply patches</small>
                          </div>
                          <div class="ot-row__column otsc-metadata-value">
                            <p>{{currentActivity.skipReapply}}</p>
                          </div>
                        </div>
                        <div class="ot-row">
                          <div class="ot-row__column otsc-metadata-key">
                            <small class="ot--has-text-muted" i18n>Update</small>
                          </div>
                          <div class="ot-row__column otsc-metadata-value">
                            <p>{{currentActivity.updateToBeInstalled}}</p>
                          </div>
                        </div>
                        <div class="ot-row">
                          <div class="ot-row__column otsc-metadata-key">
                            <small class="ot--has-text-muted" i18n>Language packs</small>
                          </div>
                          <div class="ot-row__column otsc-metadata-value">
                            <p>{{currentActivity.langPackToBeInstalled}}</p>
                          </div>
                        </div>
                        <div class="ot-row">
                          <div class="ot-row__column otsc-metadata-key">
                            <small class="ot--has-text-muted" i18n>Patches to be installed</small>
                          </div>
                          <div class="ot-row__column otsc-metadata-value">
                            <p>{{currentActivity.patchesToBeInstalled}}</p>
                          </div>
                        </div>
                        <div class="ot-row">
                          <div class="ot-row__column otsc-metadata-key">
                            @if (currentActivity.skipReapplyValue) {
                              <small class="ot--has-text-muted" i18n>Patches not reapplied</small>
                            }
                            @if (!currentActivity.skipReapplyValue) {
                              <small class="ot--has-text-muted" i18n>Patches to be reapplied</small>
                            }
                          </div>
                          <div class="ot-row__column otsc-metadata-value">
                            <p>{{currentActivity.patchesToReApply}}</p>
                          </div>
                        </div>
                        <div class="ot-row">
                          <div class="ot-row__column otsc-metadata-key">
                            <small class="ot--has-text-muted" i18n>Patches to be removed</small>
                          </div>
                          <div class="ot-row__column otsc-metadata-value">
                            <p>{{currentActivity.patchesToBeRemoved}}</p>
                          </div>
                        </div>
                      }
                      @if(currentActivity.name == 'REMOVE_PATCHES') {
                        <div class="ot-row">
                          <div class="ot-row__column otsc-metadata-key">
                            <small class="ot--has-text-muted" i18n>Removal type:</small>
                          </div>
                          <div class="ot-row__column otsc-metadata-value">
                            @if(currentActivity.installTaskType == 0) {
                              <p i18n>Classic</p>
                            } @else {
                              <p i18n>Zero downtime</p>
                            }
                          </div>
                        </div>
                        <div class="ot-row">
                          <div class="ot-row__column otsc-metadata-key">
                            <small class="ot--has-text-muted" i18n>Patches to be removed</small>
                          </div>
                          <div class="ot-row__column otsc-metadata-value">
                            <p>{{currentActivity.patchesToBeRemoved}}</p>
                          </div>
                        </div>
                        <div class="ot-row">
                          <div class="ot-row__column otsc-metadata-key">
                            <small class="ot--has-text-muted" i18n>Files to replace from update</small>
                          </div>
                          <div class="ot-row__column otsc-metadata-value">
                            <p>{{currentActivity.filesToReplace}}</p>
                          </div>
                        </div>
                        <div class="ot-row">
                          <div class="ot-row__column otsc-metadata-key">
                            <small class="ot--has-text-muted" i18n>Language packs to be reapplied</small>
                          </div>
                          <div class="ot-row__column otsc-metadata-value">
                            <p>{{currentActivity.langPackToReapply}}</p>
                          </div>
                        </div>
                        <div class="ot-row">
                          <div class="ot-row__column otsc-metadata-key">
                            <small class="ot--has-text-muted" i18n>Patches to be reapplied</small>
                          </div>
                          <div class="ot-row__column otsc-metadata-value">
                            <p>{{currentActivity.patchesToReApply}}</p>
                          </div>
                        </div>
                      }
                    </div>
                  </ng-scrollbar>
                }
              </div>
            }
            @if (activePropertyTab === ActivityPropertyTab.SUMMARY) {
              <div id="otsc-activity-summary" class="otsc-activities-section">
                <div class="otsc-activities-section-title ot-pl-3 ot-pr-3" i18n>Summary</div>
                <div class="ot-pt-1 ot-pb-1 ot-pl-3 ot-pr-3 table-container">
                  @if (currentActivity.isTaskActivity) {
                    <app-datatable [identifier]="'activities-other-summary-table'" [cols]="activitySummaryCol" [rows]="activitySummaryRow" (onclickrowlink)="viewTaskErrorMessage($event)"></app-datatable>
                  }
                  @if (!currentActivity.isTaskActivity) {
                    <app-datatable [identifier]="'activities-other-summary-table'" [cols]="activitySummaryCol" [rows]="activitySummaryRow" (onclickrowlink)="viewTaskErrorMessage($event)"></app-datatable>
                  }
                </div>
              </div>
            }
            @if (activePropertyTab === ActivityPropertyTab.SYSTEMS) {
              <div id="otsc-activity-systems" class="otsc-activities-section">
                <div class="otsc-activities-section-title ot-pl-3 ot-pr-3" i18n>Systems</div>
                <div class="ot-pt-1 ot-pb-1 ot-pl-3 ot-pr-3 table-container">
                  <app-datatable [identifier]="'activities-other-systems-table'" [cols]="activitySystemsCol" [rows]="activitySystemsRow" (onclickrowlink)="viewSystemsDetails($event)"></app-datatable>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
